module.exports = __webpack_public_path__ + "fonts/ProximaNova-Regular.7bc9ce4.otf";